import { render } from "./EditQuestionQuizModal.vue?vue&type=template&id=c267a890&scoped=true&ts=true"
import script from "./EditQuestionQuizModal.vue?vue&type=script&lang=ts"
export * from "./EditQuestionQuizModal.vue?vue&type=script&lang=ts"

import "./EditQuestionQuizModal.vue?vue&type=style&index=0&id=c267a890&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c267a890"]])

export default __exports__